<template>
  <b-row>
    <b-col md="4">
      <label>Campaña*</label>
    </b-col>
    <b-col md="8">
      <b-form-select v-model="oferta.campaniaId" :disabled="campaniaBloqueada" @change="cambiarDuracionContrato">
        <b-form-select-option disabled selected value=""> Seleccione la campaña </b-form-select-option>
        <b-form-select-option v-for="campania in campanias" :key="campania.id" :value="campania.id">
          {{ campania.nombre }}
        </b-form-select-option>
      </b-form-select>
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from "pinia";
import { useOfertaFormStore } from "@/stores/OfertaFormStore";
import campaniasApi from "@/services/campanias";

export default {
  components: {},
  props: {
    disabled: { type: Boolean, default: false },
  },
  computed: {
    ...mapState(useOfertaFormStore, ["oferta"]),
    campaniaBloqueada() {
      return this.disabled || this.campanias.length < 1;
    },
    campaniaActual() {
      return this.campanias.find((c) => c.id == this.oferta.campaniaId);
    },
  },
  mounted() {
    this.cargarCampanias();
  },
  methods: {
    cambiarDuracionContrato() {
      this.oferta.duracionContratoId = this.campaniaActual.duracionContratoDefault;
    },
    async cargarCampanias() {
      this.campanias = await campaniasApi.listarConDescuentosFirma();
    },
  },
  data() {
    return {
      campanias: [],
    };
  },
};
</script>
